import { createBrowserRouter } from 'react-router-dom';
import { AppShell } from '../app/AppShell';
import { RequireSession } from '../app/RequireSession';
import { Login } from './Login';
import { ForgotPassword } from './ForgotPassword';
import { ResetPassword } from './ResetPassword';
import { NotFound } from './NotFound';
import { Overview } from './Overview';
import { Devices } from './Devices';
import { Layouts } from './Layouts';
import { Screens } from './Screens';
import { Schedule } from './Schedule';
import { Submissions } from './Submissions';
import { Deployments } from './Deployments';
import { Media } from './Media';
import { Settings } from './Settings';
import { Integrations } from './Integrations';
import { DataSources } from './DataSources';
import { Placeholder } from './Placeholder';
import { RouteError } from './RouteError';
// Dev-only gallery; `import.meta.env.DEV` gates its route below so the production
// bundle has no /__preview route and tree-shakes this import away.
import { Preview } from './Preview';

export const router = createBrowserRouter([
  { path: '/login', element: <Login />, errorElement: <RouteError /> },
  { path: '/forgot-password', element: <ForgotPassword />, errorElement: <RouteError /> },
  { path: '/reset-password', element: <ResetPassword />, errorElement: <RouteError /> },
  // Dev-only preset gallery (owner review). Top-level (no auth/shell) so it is
  // directly reviewable; `import.meta.env.DEV` is a literal false in a production
  // build, so this route does not exist in the shipped SPA.
  ...(import.meta.env.DEV ? [{ path: '/__preview', element: <Preview />, errorElement: <RouteError /> }] : []),
  {
    element: <RequireSession />,
    errorElement: <RouteError />,
    children: [
      {
        element: <AppShell />,
        children: [
          { index: true, element: <Overview /> },
          { path: 'devices', element: <Devices /> },
          { path: 'screens', element: <Screens /> },
          { path: 'schedule', element: <Schedule /> },
          { path: 'layouts', element: <Layouts /> },
          { path: 'deployments', element: <Deployments /> },
          { path: 'media', element: <Media /> },
          { path: 'submissions', element: <Submissions /> },
          { path: 'integrations', element: <Integrations /> },
          { path: 'data-sources', element: <DataSources /> },
          { path: 'settings', element: <Settings /> },
          { path: '*', element: <NotFound /> }
        ]
      }
    ]
  }
]);
